import * as Yup from "yup";
import { ProjectInitialValue, ProjectListData } from "../../types/organization/OrganizationList";


export const projectData: ProjectListData[] = [
  {
    id: 1,
    image: "dashboard-8/linnk_logo.png",
    name: "Linnk Group",
    industry: "Information Technology & Services",
    country: "United States",
    city: "New York",
    timezone: "UTC-05:00",
    currency: "USD",
    entity: 120,
    users: 1450,
    status: "Active",
    contactPerson: "John Doe",
    email: "john@linnk.com",
    mobileNumber: "+1 555-0100",
    address: "123 5th Avenue, NY",
    accountType:"Enterprise",
    PageLimit:"10",
    expireyDate:"16/07/2025",
    distributor:"Alpha Distributors",
    franchise:"Sunrise Mart",
    androidKey:"L-1234567890",
    androidURL:"https://play.google.com/details?id=com.linnk.employee",
    iosKey:"I-1234567890",
    iosURL:"https://apps.apple.com/id1234567890",
    authority:"Enterprise",
    GoogleKey:"A-4567",
    languages:["English"],
    subscriptionType:"Free",
    dateFormat:"dd/mm/yyyy"

  },
  {
    id: 2,
    image: "dashboard-8/eduspark.png",
    name: "EduSpark",
    industry: "Education",
    country: "India",
    city: "Bangalore",
    timezone: "UTC+5:30",
    currency: "INR",
    entity: 60,
    users: 700,
    status: "Active",
    contactPerson: "Priya Shah",
    email: "priya@eduspark.in",
    mobileNumber: "+91 98765 43210",
    address: "MG Road, Bangalore",
    accountType:"Educational",
    PageLimit:"10",
    expireyDate:"16/07/2025",
    distributor:"Alpha Distributors",
    franchise:"Sunrise Mart",
    GoogleKey:"A-123456789",
    androidKey:"L-123456789",
    androidURL:"https://play.google.com/details?id=com.linnk.employee",
    iosKey:"I-123456789",
    iosURL:"https://apps.apple.com/id1234567890",
    authority:"Education",
    languages:["English"],
    subscriptionType:"Free",
    dateFormat:"dd/mm/yyyy"
      
  },
  {
    id: 3,
    image: "dashboard-8/bluefin.png",
    name: "BlueFin Capital",
    industry: "Financial Services",
    country: "Germany",
    city: "Frankfurt",
    timezone: "UTC+1",
    currency: "EUR",
    entity: 110,
    users: 980,
    status: "Active",
    contactPerson: "Hans Müller",
    email: "hans@bluefin.de",
    mobileNumber: "+49 170 1234567",
    address: "Main Tower, Frankfurt",
    accountType:"Enterprise",
    PageLimit:"10",
    expireyDate:"16/07/2025",
    distributor:"Alpha Distributors",
    franchise:"Sunrise Mart",
    GoogleKey:"A-123456789",
    androidKey:"L-1234789",
    androidURL:"https://play.google.com/details?id",
    iosKey:"I-123456789",
    iosURL:"https://apps.apple.com/app/id",
    authority:"Enterprise",
    languages:["English","German"],
    subscriptionType:"Free",
    dateFormat:"dd/mm/yyyy"
  }
];
export const projectInitialValue: ProjectInitialValue = {
  title: "",
  client: "",
  progress: 0,
  type: "",
  priority: "",
  size: "",
  description: "",
};

export const projectValidation = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  client: Yup.string().required("Client Name is required"),
  description: Yup.string().required("Some Details is required"),
  progress: Yup.number().required("Between 0 to 100").max(100),
});
